import { BUYERS_ACTIVITY_TRACK_TYPE } from 'models/Lead';

export const MEMBER_ACTIVITY_EVENT_TITLE_COPY = {
  [BUYERS_ACTIVITY_TRACK_TYPE.PLATFORM]: 'platformEvents',
  [BUYERS_ACTIVITY_TRACK_TYPE.NOTIFICATION]: 'notificationEvents',
  [BUYERS_ACTIVITY_TRACK_TYPE.DATA_ROOM]: 'dataRoomEvents',
};

export const MEMBER_ACTIVITY_EVENT_DESCRIPTION_COPY = {
  [BUYERS_ACTIVITY_TRACK_TYPE.PLATFORM]: 'platformEventsOptionDescription',
  [BUYERS_ACTIVITY_TRACK_TYPE.NOTIFICATION]:
    'notificationEventsOptionDescription',
  [BUYERS_ACTIVITY_TRACK_TYPE.DATA_ROOM]: 'dataRoomEventsOptionDescription',
};
